export default __webpack_public_path__ + "static/media/oldfog6.9cda805e.png";